import { render, staticRenderFns } from "./agentAnnounce.vue?vue&type=template&id=527c796d&"
import script from "./agentAnnounce.vue?vue&type=script&lang=js&"
export * from "./agentAnnounce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports